import './carousel.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import image1 from '../../../../assets/image.png';
import image2 from '../../../../assets/image2.png';
import image3 from '../../../../assets/image3.png';
import backgroundVideo from '../../../../assets/background.mp4'; // Import the background video

const LandingCarousel = () => {
  const navigate = useNavigate();

  const [animatedWord, setAnimatedWord] = useState(0); // 0: none, 1: BOOK, 2: BATTLE, 3: BUY

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimatedWord(prevWord => {
        if (prevWord === 3) {
          return 1; // Loop back to BOOK
        } else {
          return prevWord + 1;
        }
      });
    }, 1000); // Change word every 1 second

    // Initial delay for the first word to light up
    const initialDelay = setTimeout(() => setAnimatedWord(1), 500);

    return () => {
      clearInterval(interval);
      clearTimeout(initialDelay);
    };
  }, []);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [
    image1,
    image2,
    image3,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="min-h-screen relative flex items-center justify-center bg-black overflow-hidden">
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover opacity-50"
          src={backgroundVideo}
        ></video>
      </div>
      {/* Background elements */}
      {/* <div className="absolute inset-0 bg-gradient-to-br from-purple-900 to-black opacity-75"></div> */}
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none">
        <div className="absolute w-64 h-64 bg-[#D9A82F] rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob top-0 left-0"></div>
        <div className="absolute w-64 h-64 bg-[#EAEAEA] rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000 top-0 right-0"></div>
        <div className="absolute w-64 h-64 bg-[#9E8110] rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000 bottom-0 left-0"></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 p-6 max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-start gap-12 w-full">

        {/* Left Section - Text Content */}
        <div className="lg:w-1/3 text-left space-y-8 pt-10">
          <div className="flex items-center gap-2 bg-[#151515] bg-opacity-10 rounded-full px-1 py-1 mb-4">
            <div className="flex -space-x-1">
              <img src={image1} alt="Cafe 1" className="w-3 h-3 rounded-full object-cover" />
              <img src={image2} alt="Cafe 2" className="w-3 h-3 rounded-full object-cover" />
              <img src={image3} alt="Cafe 3" className="w-3 h-3 rounded-full object-cover" />
            </div>
            <span className="text-sm font-medium text-[#EAEAEA]">150+ cafes listed</span>
          </div>

          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-3 leading-tight">
              <span className={`block text-[#EAEAEA] ${animatedWord === 1 ? 'lit-up' : ''}`}>BOOK,</span>
              <span className={`block text-[#D9A82F] ${animatedWord === 2 ? 'lit-up' : ''}`}>BATTLE,</span>
              <span className={`block text-[#EAEAEA] ${animatedWord === 3 ? 'lit-up' : ''}`}>BUY</span>
            </h1>
            <p className="text-base text-[#EAEAEA] max-w-xl">
              Explore top gaming cafes, track esports tournaments, and join India's growing gamer network — all in one platform.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-start justify-start">
            <div className="relative">
              <button 
                onClick={() => {
                  navigate('/explore') // Explore gaming cafes
                }}
                className="bg-[#D9A82F] text-[#151515] px-8 py-3 rounded-full text-lg font-semibold flex items-center space-x-2 transform transition-transform duration-200 hover:scale-105 hover:bg-[#9E8110]"
              >
                <span>Explore Gaming</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Right Section - Fighting Animation */}
        <div className="lg:w-2/3 flex justify-end items-start pt-10">
          {/* FightingAnimation component removed */}
        </div>
      </div>
    </div>
  );
};

export default LandingCarousel;
